import { render } from "./SubscriptionPay.vue?vue&type=template&id=46f25ba5&scoped=true"
import script from "./SubscriptionPay.vue?vue&type=script&lang=js"
export * from "./SubscriptionPay.vue?vue&type=script&lang=js"

import "./SubscriptionPay.vue?vue&type=style&index=0&id=46f25ba5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f25ba5"]])

export default __exports__